<template>
    <div class="login-page">
        <!-- LEFT PANEL: imagen + glass card -->
        <div class="lp-left">
            <div class="glass-card">
                <span class="module-badge">RRHH</span>
                <h1 class="hero-title">Gestión<br>Humana</h1>
                <p class="hero-desc">Recibe, revisa y firma tus documentos laborales de forma digital y segura.</p>
            </div>
        </div>

        <!-- RIGHT PANEL: formulario -->
        <div class="lp-right">
            <login-form />
        </div>
    </div>
</template>

<script>
import LoginForm from '@/components/Login/LoginForm.vue';

export default {
    name: 'Login',
    components: { LoginForm },
    mounted() {
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
    },
    beforeDestroy() {
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
    },
};
</script>

<style scoped>
.login-page {
    display: flex;
    height: 100vh;
    overflow: hidden;
    font-family: 'Poppins', 'Segoe UI', sans-serif;
}

/* ── LEFT PANEL ── */
.lp-left {
    flex: 1;
    position: relative;
    overflow: hidden;
    min-width: 0;
    background-image: url('~@/assets/images/layout/login-bg.jpg');
    background-size: cover;
    background-position: center center;
}

.lp-left::after {
    content: '';
    position: absolute;
    inset: 0;
    background:
        linear-gradient(to bottom, rgba(5, 18, 40, 0.14), rgba(7, 20, 44, 0.32)),
        linear-gradient(135deg, rgba(24, 66, 137, 0.08), rgba(11, 29, 60, 0.24));
    z-index: 1;
    pointer-events: none;
}

/* Glass card */
.glass-card {
    position: absolute;
    left: clamp(24px, 3vw, 42px);
    right: clamp(24px, 3vw, 42px);
    bottom: clamp(24px, 3vh, 38px);
    max-width: 520px;
    background: rgba(6, 21, 47, 0.18);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border: 1px solid rgba(255, 255, 255, 0.22);
    border-radius: 24px;
    padding: clamp(18px, 2vw, 24px) clamp(20px, 2.2vw, 26px);
    z-index: 2;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.module-badge {
    display: inline-block;
    background: rgba(255, 255, 255, 0.16);
    color: #ffffff;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    padding: 4px 14px;
    border-radius: 999px;
    width: fit-content;
}

.hero-title {
    font-size: clamp(2rem, 3vw, 3.4rem);
    font-weight: 700;
    color: #ffffff;
    line-height: 0.98;
    margin: 0;
}

.hero-desc {
    font-size: 15px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.88);
    line-height: 1.6;
    margin: 0;
}

/* ── RIGHT PANEL ── */
.lp-right {
    width: clamp(410px, 41vw, 620px);
    background: #ffffff;
    border-radius: 30px 0 0 30px;
    box-shadow: -8px 0 36px rgba(8, 18, 38, 0.08);
    margin-left: clamp(-42px, -2vw, -18px);
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow-y: auto;
    flex-shrink: 0;
}

/* ── RESPONSIVE ── */
@media (max-width: 768px) {
    .login-page {
        flex-direction: column;
    }

    .lp-left {
        min-height: 34vh;
        flex: none;
    }

    .lp-right {
        width: 100%;
        margin-left: 0;
        margin-top: -22px;
        border-radius: 28px 28px 0 0;
        flex: 1;
        align-items: flex-start;
        padding-top: 8px;
    }

    .glass-card {
        right: clamp(24px, 3vw, 42px);
        max-width: 100%;
    }
}

@media (max-height: 760px) {
    .lp-right {
        align-items: flex-start;
    }
}
</style>
